<form [formGroup]="fG">
  <ejs-numerictextbox [formControlName]="fCN" [cssClass]="cssClass + ' ' + (fG.controls[fCN].invalid && fG.controls[fCN].dirty ? 'e-error' : '')" format='###.##' [step]="step" [min]="min" [max]="max"></ejs-numerictextbox>
</form>
